/**
 * @copyright Copyright (c) 2015, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:bskinner@pacificbiosciences.com">Brian Skinner</a>
 */

import {Facet} from "../facets/facet"
import {CCS_READ_FRAME, CHILD_CCS_READ_FRAME, PARENT_CCS_READ_FRAME, FLATTENED_CCS_READ_FRAME} from "../frames/ccs-read"
import { multisort, desc, valueToDate } from "../../core/utils/property-sort"

export const CCS_READ_FACET = new Facet({
    frame: CCS_READ_FRAME,
    defaultColumns: [
        "name", "numChildren", "wellSampleName", "bioSampleName", "dnaBarcodeName", "runName", "createdAt", "createdBy"],
    initialSort: multisort(desc(valueToDate("updatedAt")), desc(valueToDate("createdAt"))),
    additionalColumns: [
        "id", "cellId", "cellIndex", "totalLength",  "instrumentName", "wellName",
        "jobId", "uuid", "path", "updatedAt",
        "tags", "projectId", "version", "md5", "comments",
        "numRecords", "metadataContextId"],
    displayProperties: [
        "name", "runName", "cellIndex","numRecords", "totalLength",
        "createdAt", "instrumentName", "wellName", "wellSampleName",
        "bioSampleName", "plateId", "jobId", "id", "uuid", "path", "updatedAt",
        "tags", "projectId", "version", "md5", "createdBy", "comments",
        "metadataContextId"]
})

export const CHILD_CCS_READ_FACET = Object.assign({}, CCS_READ_FACET)
CHILD_CCS_READ_FACET.defaultColumns =
    ["name", "wellSampleName", "bioSampleName", "dnaBarcodeName", "runName", "createdAt", "createdBy"]
CHILD_CCS_READ_FACET.frame = CHILD_CCS_READ_FRAME

export const PARENT_CCS_READ_FACET = Object.assign({}, CCS_READ_FACET)
PARENT_CCS_READ_FACET.frame = PARENT_CCS_READ_FRAME

export const FLATTENED_CCS_READ_FACET = Object.assign({}, CCS_READ_FACET)
FLATTENED_CCS_READ_FACET.defaultColumns = FLATTENED_CCS_READ_FACET.defaultColumns.filter( col => col !== "numChildren")
FLATTENED_CCS_READ_FACET.frame = FLATTENED_CCS_READ_FRAME

export const CCS_READ_FACET_WITHOUT_CHILD_COL = Object.assign({}, CCS_READ_FACET)
CCS_READ_FACET_WITHOUT_CHILD_COL.defaultColumns =
    CCS_READ_FACET_WITHOUT_CHILD_COL.defaultColumns.filter( col => col !== "numChildren")
